import React from 'react';
import { Box, Typography } from '@mui/material';
import { acmePageBlockHeaderSx, acmePageBlockTitleSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

/** Section title inside a page card — pair with PageHeader above the block. */
export default function PageBlockTitle({ children, sx, gutterBottom = false }) {
  return (
    <Typography
      component="h2"
      sx={mergeSx(acmePageBlockTitleSx, gutterBottom && { mb: 2 }, sx)}
    >
      {children}
    </Typography>
  );
}

/** Title row with actions on the right (Contact Groups pattern). */
export function PageBlockHeader({ children, sx }) {
  return <Box sx={mergeSx(acmePageBlockHeaderSx, sx)}>{children}</Box>;
}
